"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ACCOUNT_TIME_ZONE = void 0;
exports.getAccountTimeZoneOptions = getAccountTimeZoneOptions;
exports.isValidTimeZone = isValidTimeZone;
exports.DEFAULT_ACCOUNT_TIME_ZONE = 'America/New_York';
function supportedTimeZones() {
    const { supportedValuesOf } = Intl;
    if (typeof supportedValuesOf !== 'function') {
        return [exports.DEFAULT_ACCOUNT_TIME_ZONE];
    }
    return supportedValuesOf('timeZone');
}
function offsetLabel(timeZone, date) {
    var _a, _b;
    const raw = (_b = (_a = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'longOffset',
    })
        .formatToParts(date)
        .find((part) => part.type === 'timeZoneName')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 'GMT';
    if (raw === 'GMT' || raw === 'UTC')
        return 'UTC+00:00';
    return raw.replace('GMT', 'UTC');
}
function placeName(timeZone) {
    const slash = timeZone.indexOf('/');
    if (slash === -1)
        return null;
    return timeZone
        .slice(slash + 1)
        .replace(/_/g, ' ')
        .replace(/\//g, ' / ');
}
function genericName(timeZone, date) {
    var _a, _b;
    return ((_b = (_a = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'longGeneric',
    })
        .formatToParts(date)
        .find((part) => part.type === 'timeZoneName')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null);
}
function formatTimeZoneLabel(timeZone, date) {
    const offset = offsetLabel(timeZone, date);
    const place = placeName(timeZone);
    const generic = genericName(timeZone, date);
    if (!place)
        return `(${offset}) ${generic !== null && generic !== void 0 ? generic : timeZone}`;
    if (!generic || generic === place)
        return `(${offset}) ${place}`;
    return `(${offset}) ${generic} — ${place}`;
}
let cachedOptions = null;
function getAccountTimeZoneOptions() {
    if (cachedOptions)
        return cachedOptions;
    const date = new Date();
    cachedOptions = supportedTimeZones().map((timeZone) => ({
        value: timeZone,
        label: formatTimeZoneLabel(timeZone, date),
    }));
    return cachedOptions;
}
function isValidTimeZone(timeZone) {
    if (!timeZone)
        return false;
    try {
        Intl.DateTimeFormat('en-US', { timeZone });
        return true;
    }
    catch (_a) {
        return false;
    }
}
